import { Box, Grid, Typography, Card } from "@mui/material";

const steps = [
  {
    title: "Loosen the Soil",
    desc: "Use a garden fork to loosen the top layer of soil around the plant."
  },
  {
    title: "Apply Vermicompost",
    desc: "Sprinkle an appropriate amount of vermicompost near the roots."
  },
  {
    title: "Cover the Soil",
    desc: "Lightly mix the compost with soil for even nutrient distribution."
  },
  {
    title: "Water Lightly",
    desc: "Gently water to activate nutrients and help absorption."
  }
];

export default function HowToUse() {
  return (
    <Box bgcolor="#1F4D2B" py={{ xs: 8, md: 12 }}>
      <Typography
        variant="h2"
        color="#fff"
        textAlign="center"
        mb={2}
      >
        How to Use Vermicompost
      </Typography>

      <Typography
        color="#D9E3DA"
        textAlign="center"
        maxWidth={600}
        mx="auto"
        mb={6}
      >
        Follow these simple steps to get the best results from our organic
        vermicompost.
      </Typography>

      <Grid
        container
        spacing={4}
        px={{ xs: 2, md: 10 }}
        justifyContent="center"
      >
        {steps.map((step, index) => (
          <Grid item xs={12} sm={6} md={3} key={step.title}>
            <Card
              sx={{
                height: "100%",
                bgcolor: "rgba(255,255,255,0.08)",
                color: "#fff",
                p: 3,
                borderRadius: 3,
                textAlign: "center"
              }}
            >
              <Typography
                variant="h4"
                color="secondary"
                fontWeight={700}
              >
                0{index + 1}
              </Typography>

              <Typography variant="h6" mt={2} mb={1}>
                {step.title}
              </Typography>

              <Typography
                variant="body2"
                color="#D9E3DA"
              >
                {step.desc}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
